<template>
    <div class="pcr-system-menu">
        <el-row>
            <el-col :span="12" v-if="establishmentId === 1">
                <a class="biglink" href="/GuideManagement/Index/">
                    <el-row>
                        <el-col :span="4">
                            <img src="/Content/images/folder.png">
                        </el-col>
                        <el-col :span="20">
                            <div class="biglink-content">
                                <h5>Administrer le guide</h5>
                                <p>Cette section permet d'administer le guide. Créer de nouveaux modèles de documents, mettre à jour les descriptions, etc.</p>
                            </div>
                        </el-col>
                    </el-row>
                </a>
            </el-col>
            <el-col :span="12" v-if="establishmentId === 1">
                <router-link :to="{ query: { establishmentId: 1, SQLAdmin: true }}" class="biglink">
                    <el-row>
                        <el-col :span="4">
                            <i class="fa fa-database fa-5x" aria-hidden="true" style="padding: 16px;"></i>
                        </el-col>
                        <el-col :span="20">
                            <div class="biglink-content">
                                <h5>Administrer les requêtes SQL</h5>
                                <p>Cette section permet d'administer les requêtes SQl de la plateforme. Créer de nouvelles requêtes, les éxécuter, les assignées à un établissement ou un utilisateur.</p>
                            </div>
                        </el-col>
                    </el-row>
                </router-link>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Vue from "vue";
export default Vue.component("system-menu", {
  props: {
    establishmentId: {
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  data() {
    return {};
  },
  mounted: function() {},
  methods: {},
  watch: {
  }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/system/system-menu.vue